import { useEffect, useState } from "react";
import axios from "../../../axios";
import { Link, useNavigate } from "react-router-dom";
import ErrorModal from "../../components/ErrorModal";
import handleApiError from "../../../utils/handleApiError";
import SuccessModal from "../../components/SuccessModal";
import { STORAGE_URL } from "../../../constants";

export default function BannerListPage() {
    const [banners, setBanners] = useState([]);
    const navigate = useNavigate();
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        axios.get("/admin/banners").then((res) => setBanners(res.data));
    }, []);

    const handleDelete = async (id) => {
        if (window.confirm("Nonaktifkan banner ini?")) {
            try {
                await axios.delete(`/admin/banners/${id}`);
                setSuccess("Data berhasil diHapus!");
                setBanners(banners.map(b => b.id === id ? { ...b, is_active: false } : b));
            } catch (err) {
                setError(handleApiError(err));
            } finally {
                setLoading(false);
            }
        }
    };

    return (
        <div className="card mt-24">
            <div className="card-header border-bottom">
                <h4 className="mb-4">Daftar Banner</h4>
            </div>
            <div className="card-body">
                <ErrorModal error={error} onClose={() => setError("")} />
                <SuccessModal
                    message={success}
                    onClose={() => {
                        setSuccess("");
                        navigate("/admin/banners");
                    }}
                />
                <Link to="/admin/banners/create" className="btn btn-success mb-3">Tambah Banner</Link>
                <table className="table">
                    <thead>
                        <tr>
                            <th>Gambar</th>
                            <th>Judul</th>
                            <th>Status</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {banners.map((b) => (
                            <tr key={b.id}>
                                <td>
                                    <img src={`${STORAGE_URL}${b.image}`} width={100} alt="Banner" />
                                </td>
                                <td>{b.title}</td>
                                <td>{b.is_active ? "Aktif" : "Nonaktif"}</td>
                                <td>
                                    <Link to={`/admin/banners/${b.id}/edit`} className="btn btn-sm btn-warning">Edit</Link>{" "}
                                    {b.is_active && (
                                        <button className="btn btn-sm btn-danger" onClick={() => handleDelete(b.id)}>Nonaktifkan</button>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
